import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxHelper } from '../../core/utils/rxjxHelper';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RegionStore } from '../../core/store/region.store';
import { CheckboxModule } from 'primeng/checkbox';
import { RegionNameComponent } from '../region-name/region-name.component';
import { RegionId } from '../../core/model/region-id.enum';
import { SelectionModel } from '@angular/cdk/collections';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-regions-select',
    standalone: true,
    imports: [CommonModule, CheckboxModule, RegionNameComponent, FormsModule, RadioButtonModule],
    templateUrl: './regions-select.component.html',
    styleUrls: ['./regions-select.component.scss'],
    providers: [
        RxHelper,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RegionsSelectComponent),
            multi: true,
        },
    ],
})
export class RegionsSelectComponent implements OnInit, ControlValueAccessor {
    @Input() showNone = true;
    @Input() isDisabled = false;

    private readonly _store = inject(RegionStore);
    private readonly _rxHelper = inject(RxHelper);
    protected readonly selectionModel = new SelectionModel<RegionId | null>(false);

    protected onChangeFn?: (value: RegionId | null) => unknown;
    protected onTouchedFn?: () => unknown;
    protected readonly regions$ = this._store.regions$;

    ngOnInit() {
        this.selectionModel.changed.pipe(this._rxHelper.autoUnsubscribe).subscribe(() => {
            this.onChangeFn?.(this.selectionModel.selected[0]);
        });
        this.selectionModel.select(null);
    }

    writeValue(obj: unknown): void {
        if (typeof obj === 'number') {
            this.selectionModel.select(obj);
        } else {
            this.selectionModel.select(null);
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }
}
